import {ApprovalStatus} from '@domain/shared'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {QueryKeyName, updateActionApproval} from '../../common/backend'

type UseApprovalParams = {
  plantId: string
  concurrencyStamp: string
}

export const useActionApproval = ({plantId, concurrencyStamp}: UseApprovalParams) => {
  const client = useQueryClient()

  return useMutation<unknown, AxiosError, {actionId: string; approvalStatus: ApprovalStatus}>({
    mutationFn: ({actionId, approvalStatus}) =>
      updateActionApproval({plantId, actionId, approvalStatus, concurrencyStamp}),
    onSuccess: () => {
      void client.invalidateQueries({queryKey: [QueryKeyName.GetActionItems]})
    }
  })
}
